/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Memberships. List of Memberships.
 */
export interface MembershipResult { 
    /**
     * Id Hash. UUI (Unique User Identifier).
     */
    userIdHash?: string;
    /**
     * Id Hash. UCI (Unique Company Identifier).
     */
    companyIdHash?: string;
    /**
     * Company department name.
     */
    companyDepartmentName?: string;
    /**
     * Date Not Before. Format yyyy-MM-dd HH:mm:ss
     */
    notBefore?: string;
    /**
     * Date Not After. Format yyyy-MM-dd HH:mm:ss
     */
    notAfter?: string;
    /**
     * User role in this company.
     */
    role?: string;
    /**
     * User membership number in this company.
     */
    membershipNumber?: string;
    /**
     * User membership type in this company.
     */
    membershipType?: string;
    /**
     * User membership QR or Barcode in this company, it\'s an image, encoded in Base64 format.
     */
    membershipQR?: MembershipResult.MembershipQREnum;
    /**
     * Additional information that some types of memberships may require. Example: in the case of a minor’s hunting license, this field should contain the identifier of the accompanying adult’s hunting license (for example: \'TD012345F-903245\'). Maximum lenght 255
     */
    additionalInformation?: string;
}
export namespace MembershipResult {
    export const MembershipQREnum = {
        Bc2e3264: '[B@c2e3264'
    } as const;
    export type MembershipQREnum = typeof MembershipQREnum[keyof typeof MembershipQREnum];
}


